export const FEATURE_FLAG_SESSION_STORAGE_EVENT = "FEATURE_FLAGS_SESSION_STORAGE_EVENT";
export const FEATURE_FLAG_SESSION_STORAGE_KEY = "gx_feature_flags";
export const FEATURE_FLAG_SESSION_STORAGE_LOCKED_KEY = "gx_feature_flags.locked";
